import { ChevronRight, Domain as IconClient } from "@mui/icons-material";
import { Button, Grid2, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { GqlDashboardClientUserClientList } from "~/__generated__";

type Props = {
    component: GqlDashboardClientUserClientList;
};

export default function DashboardClientUserClientList({ component }: Props) {
    const { t } = useTranslation("app");
    const clients = component.clients.data;

    return (
        <Grid2 size={12}>
            <Typography variant="h3" paddingBottom={2}>
                {t("dashboardComponents.dashboardClientUserClientList.clients")}:
            </Typography>
            <Stack direction="column" rowGap={2}>
                {clients.map(client => (
                    <Paper variant="outlined" key={client.id} sx={{ padding: 2 }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center">
                            <Stack direction="row" alignItems="center" columnGap={2}>
                                <IconClient fontSize="large" />
                                <Typography variant="h3">{client.client.name}</Typography>
                            </Stack>
                            <Button endIcon={<ChevronRight />} variant="text" component={Link} to={`/c/${client.client.slug}/`}>
                                {t("dashboardComponents.dashboardClientUserClientList.allProjectsBtn")}
                            </Button>
                        </Stack>
                    </Paper>
                ))}
            </Stack>
        </Grid2>
    );
}
